import { useAuthStore } from './auth.store';

export function useAuth() {
  const session = useAuthStore((s) => s.session);
  const status = useAuthStore((s) => s.status);
  const error = useAuthStore((s) => s.error);
  const signIn = useAuthStore((s) => s.signIn);
  const signOut = useAuthStore((s) => s.signOut);
  return {
    session,
    status,
    error,
    isAuthenticated: !!session,
    signIn,
    signOut,
  };
}
